import { NavLink, useLocation } from "react-router-dom";
import { isSidebarItemActive } from "./adminNavigation";

const AdminSidebarItem = ({ item, collapsed = false, onNavigate }) => {
  const location = useLocation();
  const Icon = item.icon;
  const active = isSidebarItemActive(location.pathname, item);

  return (
    <NavLink
      to={item.to}
      className={`admin-sidebar__item${active ? " is-active" : ""}`}
      title={collapsed ? item.label : undefined}
      onClick={onNavigate}
    >
      <span className="admin-sidebar__item-icon">
        <Icon size={18} />
      </span>
      <span className="admin-sidebar__item-label">{item.label}</span>
    </NavLink>
  );
};

export default AdminSidebarItem;
